// extracted by mini-css-extract-plugin
export var dark = "layout-module--dark--h8Kzb";
export var light = "layout-module--light--CmCkG";
export var main = "layout-module--main--5FdSi";
export var overflow = "layout-module--overflow--4nd5i";
export var wrapper = "layout-module--wrapper--bRJIc";